import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b28f2dec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import BlockView from "@/components/block/BlockView.vue";
import BlockTitleView from "@/components/block/BlockTitleView.vue";
import {editor} from "@/app/editor";
import {IconFont} from "@/lib/util";
import {GroupModuleV1} from "@/app/editor/modules/group/v1/index";
import BlockContentBox from "@/components/block/BlockContentBox.vue";
import BlockContentItemKey from "@/components/block/BlockContentItemKey.vue";
import BlockContentItemValue from "@/components/block/BlockContentItemValue.vue";
import GroupSimple from "@/app/editor/modules/group/v1/GroupSimple.vue";
import GroupStepPrice from "@/app/editor/modules/group/v1/GroupStepPrice.vue";
import GroupStepGoods from "@/app/editor/modules/group/v1/GroupStepGoods.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'GroupSetup',
  props: {
    index: {}
  },
  setup(__props: any) {

const props = __props
const group = editor.activity?.modules[props.index] as GroupModuleV1


return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_flex = _resolveComponent("a-flex")!

  return (_unref(group))
    ? (_openBlock(), _createBlock(BlockView, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(BlockTitleView, null, {
            default: _withCtx(() => [
              _createVNode(_unref(IconFont), {
                type: `icon-${_unref(group).icon}`,
                style: {"padding-right":"8px"}
              }, null, 8, ["type"]),
              _createTextVNode(" " + _toDisplayString(_unref(group).title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_flex, {
            vertical: "",
            gap: "large",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                type: "info",
                "show-icon": "",
                message: _unref(group).config.type
              }, null, 8, ["message"]),
              (_unref(group).config.type=='普通团')
                ? (_openBlock(), _createBlock(GroupSimple, {
                    key: 0,
                    index: _ctx.index
                  }, null, 8, ["index"]))
                : (_unref(group).config.type=='价格阶梯团')
                  ? (_openBlock(), _createBlock(GroupStepPrice, {
                      key: 1,
                      index: _ctx.index
                    }, null, 8, ["index"]))
                  : (_openBlock(), _createBlock(GroupStepGoods, {
                      key: 2,
                      index: _ctx.index
                    }, null, 8, ["index"])),
              _createVNode(_component_a_collapse, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_panel, { header: "更多" }, {
                    default: _withCtx(() => [
                      _createVNode(BlockContentBox, null, {
                        default: _withCtx(() => [
                          _createVNode(BlockContentItemKey, null, {
                            default: _withCtx(() => [
                              _createTextVNode("按钮文案")
                            ]),
                            _: 1
                          }),
                          _createVNode(BlockContentItemValue, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _unref(group).config.props.buy_bottom_text,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(group).config.props.buy_bottom_text) = $event)),
                                "allow-clear": "",
                                "show-count": "",
                                maxlength: 8,
                                style: {"max-width":"316px"}
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(BlockContentItemKey, null, {
                            default: _withCtx(() => [
                              _createTextVNode("限购")
                            ]),
                            _: 1
                          }),
                          _createVNode(BlockContentItemValue, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input_number, {
                                value: _unref(group).config.props.customer_buy_limit,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(group).config.props.customer_buy_limit) = $event)),
                                min: 1,
                                max: 10,
                                "addon-after": "单"
                              }, null, 8, ["value"]),
                              _hoisted_1,
                              _createVNode(_component_a_typography_text, { type: "secondary" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("按手机号限制购买单数。")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(BlockContentItemKey, null, {
                            default: _withCtx(() => [
                              _createTextVNode("购买后有效期")
                            ]),
                            _: 1
                          }),
                          _createVNode(BlockContentItemValue, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input_number, {
                                value: _unref(group).config.props.goods_validity_mons,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(group).config.props.goods_validity_mons) = $event)),
                                min: 1,
                                max: 10,
                                "addon-after": "月"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(BlockContentItemKey, null, {
                            default: _withCtx(() => [
                              _createTextVNode("组团时长")
                            ]),
                            _: 1
                          }),
                          _createVNode(BlockContentItemValue, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_radio_group, {
                                value: _unref(group).config.props.group_time_limit_hours,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(group).config.props.group_time_limit_hours) = $event)),
                                options: [{label:'1天',value:24},{label:'1天半',value:36},{label:'2天',value:24*2}]
                              }, null, 8, ["value"]),
                              _hoisted_2,
                              _createVNode(_component_a_typography_text, { type: "secondary" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("在设置的时间内，没有达到最少人数的团，视为未成团。 ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})